import React from 'react';
import PropTypes from 'prop-types';

const TreeEdge = ({ d, kind }) => {
  if (!d) return null;

  const isSpouse = kind === 'spouse';

  return (
    <path
      d={d}
      fill="none"
      stroke={isSpouse ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.9)'}
      strokeWidth={isSpouse ? 1 : 2}
      strokeDasharray={isSpouse ? '4 4' : undefined}
      opacity={isSpouse ? 0.35 : 1}
      vectorEffect="non-scaling-stroke"
      pointerEvents="none"
    />
  );
};

TreeEdge.propTypes = {
  d: PropTypes.string,
  kind: PropTypes.oneOf(['parentChild', 'spouse']).isRequired,
};

TreeEdge.defaultProps = {
  d: null,
};

export default TreeEdge;
